<ng-container *ngIf="!disableContentPage; else contentWithoutWrapper">
  <gatewee-content-page
    [breadcrumb]="
      breadcrumb.length
        ? breadcrumb
        : [
            {label: titlePath | translate, path: '/panel'},
            {label: title | translate}
          ]
    "
    [title]="title | translate"
  >
    <div page-body>
      <ng-container *ngTemplateOutlet="contentTemplate"></ng-container>
    </div>
  </gatewee-content-page>
</ng-container>

<ng-template #contentWithoutWrapper>
  <ng-container *ngTemplateOutlet="contentTemplate"></ng-container>
</ng-template>

<ng-template #contentTemplate>
  <div class="gw-flex gw-justify-end gw-mb-6">
    <gatewee-button
      [title]="'features.pixKeys.buttonText' | translate"
      variant="primary"
      iconName="@phi.arrows-clockwise"
      [disabled]="loading"
      (click)="onRetrieveKeys()"
    ></gatewee-button>
  </div>

  <div
    class="gw-rounded-xl gw-shadow-sm gw-border gw-border-border-normal gw-overflow-hidden"
  >
    <gatewee-table-v2
      *ngIf="pixKeys && columns.length"
      [data]="tablePixKeys"
      [columns]="columns"
      [page]="page"
      [pageSize]="pageSize"
      [total]="total || tablePixKeys.length"
      [showSettings]="true"
      [tableId]="'pix-keys-table'"
      (outClick)="onActionClicked($event)"
      (newPage)="onPageChange($event)"
    ></gatewee-table-v2>
  </div>
</ng-template>

<!-- Key View Modal -->
<ng-template #keyViewModal let-close>
  <div
    class="gw-flex gw-items-center gw-justify-between gw-p-6 gw-border-b gw-border-border-normal"
  >
    <h4
      class="gw-text-xl gw-font-semibold gw-text-text-primary"
      id="modal-pix-key-view-title"
    >
      {{ 'features.pixKeys.view.title' | translate }}
    </h4>
  </div>
  <div class="gw-p-6" *ngIf="selectedKey">
    <div class="gw-space-y-6">
      <div class="gw-grid gw-grid-cols-1 md:gw-grid-cols-2 gw-gap-4">
        <div>
          <label
            class="gw-text-sm gw-font-medium gw-text-text-secondary gw-block gw-mb-2"
          >
            {{ 'features.pixKeys.table.columns.id' | translate }}
          </label>
          <p class="gw-text-base gw-text-text-primary">{{ selectedKey.id }}</p>
        </div>
        <div>
          <label
            class="gw-text-sm gw-font-medium gw-text-text-secondary gw-block gw-mb-2"
          >
            {{ 'features.pixKeys.table.columns.key' | translate }}
          </label>
          <p class="gw-text-base gw-text-text-primary">{{ selectedKey.key }}</p>
        </div>
        <div>
          <label
            class="gw-text-sm gw-font-medium gw-text-text-secondary gw-block gw-mb-2"
          >
            {{ 'features.pixKeys.table.columns.description' | translate }}
          </label>
          <p class="gw-text-base gw-text-text-primary">
            {{ getDescriptionDisplay(selectedKey.description) }}
          </p>
        </div>
        <div>
          <label
            class="gw-text-sm gw-font-medium gw-text-text-secondary gw-block gw-mb-2"
          >
            {{ 'features.pixKeys.table.columns.document' | translate }}
          </label>
          <p class="gw-text-base gw-text-text-primary">
            {{ getDocumentDisplay(selectedKey.document) }}
          </p>
        </div>
        <div>
          <label
            class="gw-text-sm gw-font-medium gw-text-text-secondary gw-block gw-mb-2"
          >
            {{ 'features.pixKeys.table.columns.bank' | translate }}
          </label>
          <p class="gw-text-base gw-text-text-primary">
            {{ getBankCodeDisplay(selectedKey) }}
          </p>
        </div>
        <div>
          <label
            class="gw-text-sm gw-font-medium gw-text-text-secondary gw-block gw-mb-2"
          >
            {{ 'features.pixKeys.table.columns.agency' | translate }}
          </label>
          <p class="gw-text-base gw-text-text-primary">
            {{ selectedKey.agency ?? '–' }}
          </p>
        </div>
        <div>
          <label
            class="gw-text-sm gw-font-medium gw-text-text-secondary gw-block gw-mb-2"
          >
            {{ 'features.pixKeys.table.columns.account' | translate }}
          </label>
          <p class="gw-text-base gw-text-text-primary">
            {{ selectedKey.account ?? '–' }}
          </p>
        </div>
        <div>
          <label
            class="gw-text-sm gw-font-medium gw-text-text-secondary gw-block gw-mb-2"
          >
            {{ 'features.pixKeys.table.columns.createdAt' | translate }}
          </label>
          <p class="gw-text-base gw-text-text-primary">
            {{ selectedKey.createdAt | date : 'dd/MM/yyyy HH:mm:ss' }}
          </p>
        </div>
        <div *ngIf="selectedKey.type">
          <label
            class="gw-text-sm gw-font-medium gw-text-text-secondary gw-block gw-mb-2"
          >
            {{ 'features.pixKeys.view.type' | translate }}
          </label>
          <p class="gw-text-base gw-text-text-primary">
            {{ selectedKey.type }}
          </p>
        </div>
        <div *ngIf="selectedKey.provider">
          <label
            class="gw-text-sm gw-font-medium gw-text-text-secondary gw-block gw-mb-2"
          >
            {{ 'features.pixKeys.view.provider' | translate }}
          </label>
          <p class="gw-text-base gw-text-text-primary">
            {{ selectedKey.provider }}
          </p>
        </div>
      </div>
      <div
        class="gw-flex gw-flex-wrap gw-gap-3 gw-border-t gw-border-border-normal gw-pt-6"
      >
        <gatewee-button
          *ngIf="actions.onUpdateDescription"
          [title]="'common.actions.edit' | translate"
          variant="secondary"
          (click)="openEditFromView(close)"
          [disabled]="loading"
          iconName="@tui.pencil"
        ></gatewee-button>
        <gatewee-button
          *ngIf="actions.onDisable"
          [title]="'features.pixKeys.table.menu.disable' | translate"
          variant="secondary"
          (click)="onDisableInView(close)"
          [disabled]="loading"
          iconName="@tui.ban"
        ></gatewee-button>
      </div>
    </div>
  </div>
</ng-template>

<!-- Edit Description Modal -->
<ng-template #editDescriptionModal let-close>
  <div
    class="gw-flex gw-items-center gw-justify-between gw-p-6 gw-border-b gw-border-border-normal"
  >
    <h4
      class="gw-text-xl gw-font-semibold gw-text-text-primary"
      id="modal-pix-key-edit-title"
    >
      {{ 'features.pixKeys.edit.title' | translate }}
    </h4>
  </div>
  <div class="gw-p-6" *ngIf="selectedKey">
    <form [formGroup]="editForm">
      <div class="gw-mb-4">
        <label
          class="gw-text-sm gw-font-medium gw-text-text-secondary gw-block gw-mb-2"
        >
          {{ 'features.pixKeys.table.columns.key' | translate }}
        </label>
        <p class="gw-text-base gw-text-text-primary">{{ selectedKey.key }}</p>
      </div>
      <div class="gw-mb-6">
        <gatewee-input-v2
          [form]="editForm"
          controlName="description"
          [label]="'features.pixKeys.edit.descriptionLabel' | translate"
          type="text"
          [placeholder]="
            'features.pixKeys.edit.descriptionPlaceholder' | translate
          "
        ></gatewee-input-v2>
        <p
          *ngIf="
            editForm.get('description')?.invalid &&
            editForm.get('description')?.touched
          "
          class="gw-text-sm gw-text-status-negative gw-mt-1"
        >
          {{ 'features.pixKeys.edit.errors.maxLength' | translate }}
        </p>
      </div>
      <div class="gw-flex gw-justify-end gw-gap-3">
        <gatewee-button
          [title]="'common.actions.cancel' | translate"
          variant="secondary"
          (clicked)="closeModal(close)"
          [disabled]="loading"
        ></gatewee-button>
        <gatewee-button
          [title]="'common.actions.save' | translate"
          variant="primary"
          (clicked)="submitDescriptionEdit(close)"
          [disabled]="editForm.invalid || loading"
        ></gatewee-button>
      </div>
    </form>
  </div>
</ng-template>
